import Vue from 'vue';
import {Toast} from 'vant';
import Router from 'vue-router';

import home from './home';
import items from './items';
import user from './user';
import order from './order';
import login from './login';
import cms from './cms';

const notfound = () => import ( /* webpackChunkName: "tabbar-home" */ '@/views/home/notfound.vue');

Vue.use(Router);

let RouterModel = new Router({
  routes: [...home, ...items, ...user, ...order, ...login, ...cms,
    {
      path: '/404',
      name: 'error',
      components: {
        default: notfound
      },
      meta: {
        hideMenu: true
      }
    },
    {
      path: '*',
      redirect: {
        name: 'error'
      },
      meta: {
        hideMenu: true
      }
    }]
})


RouterModel.beforeEach((to, from, next) => {
	const { Authorization, user_id} = Vue.prototype.$util.getLocalStorage('Authorization', 'user_id')
	if(!Authorization && !user_id){
		if(to.meta.login){
			RouterModel.push({name: 'login', query: {redirect: to.name}});
			return;
		}
  }
  /* 路由发生变化修改页面meta */
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // else{
  //   document.title = "工家云"
  // }
	next();
})

RouterModel.afterEach((to, from) => {
})

export default RouterModel;
